import React, { Component } from 'react'
import { Modal, Select, message } from 'antd'

/**
 * 医院信息-办事流程-引用院区信息确认
 */
export default class ReferenceCourtyardModal extends Component {
    state = {
        visible: false,
        hospitalId: undefined,
    }

    show = () => {
        this.setState({
            visible: true,
            hospitalId: undefined,
        });
    }

    hide = () => {
        this.setState({
            visible: false,
        });
    }

    handleChange = (value) => {
        this.setState({ hospitalId: value });
    }

    submit = () => {
        const { hospitalId } = this.state;
        if (!hospitalId) {
            message.warning('请选择院区');
            return;
        }
        const { onConfirm } = this.props;
        this.hide();
        Modal.confirm({
            title: '办事流程数据引用确认',
            content: '将把该院区的办事流程数据复制到当前医院：已有值的字段不会被覆盖；附件、表格、流程图仅在本医院对应内容为空时复制。确定引用吗？',
            onOk() {
                onConfirm(hospitalId);
            },
            onCancel() {
            },
        });
    }

    render() {
        const { visible, hospitalId } = this.state;
        const asterisk = <span style={{ color: 'red' }}>*</span>;
        const { List } = this.props;
        const Option = Select.Option;
        const hospitalOptions = List.map(i => <Option value={i.hospitalName} key={i.hospitalId}>{i.hospitalName}</Option>)
        const courtyardAreaOptions = List.map(i =>
            <Option value={i.hospitalId} key={`area_${i.hospitalId}`}>{i.courtyardArea || i.hospitalName}</Option>)
        return (
            <Modal
                title="办事流程信息引用确认"
                visible={visible}
                onOk={this.submit}
                onCancel={this.hide}
            >
                <div className="modal-content" style={{ padding: "0 20px" }}>
                    <ul className="modal-list">
                        <li className="modal-item">
                            <div className="item-left" style={{ width: "27%" }}>{asterisk}医院:</div>
                            <div className="item-right" style={{ width: "73%" }}>
                                <Select
                                    style={{ width: 220 }}
                                    disabled={true}
                                    value={List[0] ? List[0].hospitalName : ''}
                                >
                                    {hospitalOptions}
                                </Select>
                            </div>
                        </li>
                        <li className="modal-item">
                            <div className="item-left" style={{ width: "27%" }}>{asterisk}院区:</div>
                            <div className="item-right" style={{ width: "73%" }}>
                                <Select
                                    style={{ width: 220 }}
                                    placeholder="请选择"
                                    value={hospitalId}
                                    onChange={value => this.handleChange(value)}
                                >
                                    {courtyardAreaOptions}
                                </Select>
                            </div>
                        </li>
                    </ul>
                </div>
            </Modal>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/common/workFlowTemplate/ReferenceCourtyardModal.js